const CHALLENGE_CATEGORIES = {
  vetting: "Vetting",
  role: "Role",
};

export default CHALLENGE_CATEGORIES;
